import React from "react";
import "./BusinessEmailSectionPro.css";

const emailCards = [
  {
    tag: "Business Email",
    title: "Create a branded inbox for your company",
    text: "Use professional email addresses like hello@yourbrand.com and build trust with every customer conversation.",
    points: [
      "Custom email with your domain name",
      "Clean inbox access across devices",
      "Secure setup for business communication",
    ],
    action: "Set up business email",
    visualTitle: "hello@yourbrand.com",
  },
  {
    tag: "Team Growth",
    title: "Manage team communication in one place",
    text: "Give your team simple tools for client support, sales enquiries, and daily business conversations.",
    points: [
      "Add multiple team mailboxes",
      "Use email for sales and support",
      "Ready for startups and agencies",
    ],
    action: "Explore email tools",
    visualTitle: "support@company.com",
  },
];

const BusinessEmailSectionPro = () => {
  return (
    <section className="be-section">
      <div className="be-container">
        <div className="be-heading">
          <span>Professional email</span>
          <h2>Build trust with business-ready email tools</h2>
        </div>

        <div className="be-grid">
          {emailCards.map((card) => (
            <article className="be-card" key={card.title}>
              <span className="be-tag">{card.tag}</span>
              <h3>{card.title}</h3>
              <p>{card.text}</p>

              <ul>
                {card.points.map((point) => (
                  <li key={point}>{point}</li>
                ))}
              </ul>

              <button type="button">{card.action}</button>

              <div className="be-visual">
                <div className="be-mail-box">
                  <strong>{card.visualTitle}</strong>
                  <span>Inbox • Secure • Ready</span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BusinessEmailSectionPro;